import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { NavItem } from '@app/interfaces/nav-item';
import { NavComponent } from '@app/layout/nav/nav.component';
import { NavService } from '@app/services/nav.service';
import { AccountMenuComponent } from './account-menu/account-menu.component';
import { AccountProfileBlockComponent } from './account-profile-block/account-profile-block.component';

@Component({
  selector: 'app-account-page',
  templateUrl: './account.page.html',
  styleUrls: ['./account.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NavComponent,
    AccountMenuComponent,
    RouterOutlet,
    AccountProfileBlockComponent,
  ],
})
export class AccountPage implements OnInit {
  protected navItems: NavItem[] = [];

  constructor(
    protected navService: NavService,
    private cdRef: ChangeDetectorRef,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.navService.navItems$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((navItems: NavItem[]) => {
        this.navItems = navItems;
        this.cdRef.detectChanges();
      });
  }
}
